// Anyeluz — JS propio, vanilla, sin librerías. Un init por componente,
// cada uno comprueba si su elemento existe antes de hacer nada.
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initComprarProducto();
  initCarruseles();
  initRecomendados();
  initQuickAdd();
});

function initComprarProducto() {
  document.querySelectorAll('[data-an-producto-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); anAgregar(form, false); });
    var comprar = form.querySelector('[data-an-comprar-ya]');
    if (comprar) comprar.addEventListener('click', function () { anAgregar(form, true); });
  });
}

function anAgregar(form, irCheckout) {
  var idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;
  var qtyEl = form.querySelector('input[name="quantity"]');
  var qty = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
  anAgregarVariante(idInput.value, qty, irCheckout, null);
}

// Refresca el cajón del carrito (reemplaza su HTML), lo abre y actualiza el contador.
function anRefrescarCarrito() {
  return fetch(window.location.pathname).then(function (r) { return r.text(); }).then(function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('#CartDrawer');
    var actual = document.querySelector('#CartDrawer');
    if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.classList.remove('is-empty');
      drawer.open();
    } else {
      window.location.href = '/cart';
    }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-an-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.style.display = c.item_count > 0 ? '' : 'none';
      });
    });
  });
}

// Añade una variante al carrito por AJAX. Núcleo compartido por la ficha y la compra rápida.
function anAgregarVariante(id, qty, irCheckout, btn) {
  if (!id) return Promise.resolve();
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: qty || 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status) throw new Error('add');
      if (irCheckout) { window.location.href = '/checkout'; return; }
      if (btn) {
        var etiqueta = btn.querySelector('span');
        btn.classList.add('is-ok');
        if (etiqueta) etiqueta.textContent = '¡Agregado!';
        setTimeout(function () {
          btn.classList.remove('is-ok');
          if (etiqueta) etiqueta.textContent = btn.getAttribute('data-texto') || 'Agregar';
        }, 1600);
      }
      return anRefrescarCarrito();
    })
    .catch(function () { window.location.href = irCheckout ? '/checkout' : '/cart'; });
}

// Compra rápida desde las tarjetas propias (delegado, funciona con tarjetas inyectadas).
function initQuickAdd() {
  if (window.anQuickAddListo) return;
  window.anQuickAddListo = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-an-quick-add]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.classList.contains('is-cargando')) return;
    b.classList.add('is-cargando');
    var p = anAgregarVariante(b.getAttribute('data-variant-id'), 1, false, b);
    if (p && p.then) { p.then(function () { b.classList.remove('is-cargando'); }); }
    else { b.classList.remove('is-cargando'); }
  });
}

function initReveals() {
  var els = document.querySelectorAll('.an-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('an-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-an-delay') || 0;
          setTimeout(function () { entry.target.classList.add('an-visible'); }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-an-galeria-principal]');
  var miniaturas = document.querySelectorAll('[data-an-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (min) {
    min.addEventListener('click', function () {
      var src = min.getAttribute('data-full');
      var alt = min.getAttribute('data-alt') || '';
      principal.querySelector('img').setAttribute('src', src);
      principal.querySelector('img').setAttribute('alt', alt);
      miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
      min.classList.add('is-activa');
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-an-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-an-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var botones = form.querySelectorAll('[data-an-valor]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-an-precio]');
    var precioTachadoEl = form.querySelector('[data-an-precio-tachado]');
    var anadirBtn = form.querySelector('[data-an-anadir]');
    var seleccion = {};

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opcion = btn.getAttribute('data-opcion');
        var valor = btn.getAttribute('data-an-valor');
        seleccion[opcion] = valor;
        form.querySelectorAll('[data-opcion="' + opcion + '"]').forEach(function (b) {
          b.classList.remove('is-activo');
        });
        btn.classList.add('is-activo');
        actualizar();
      });
    });

    function actualizar() {
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return !seleccion[v.optionNames[i]] || seleccion[v.optionNames[i]] === opt; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = match.priceFormatted;
      if (precioTachadoEl) {
        if (match.compareAtPriceFormatted) {
          precioTachadoEl.textContent = match.compareAtPriceFormatted;
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (anadirBtn) {
        anadirBtn.disabled = !match.available;
        anadirBtn.textContent = match.available ? anadirBtn.getAttribute('data-texto-disponible') : anadirBtn.getAttribute('data-texto-agotado');
      }
    }
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-an-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-an-menos]');
    var mas = wrap.querySelector('[data-an-mas]');
    if (!input || !menos || !mas) return;
    menos.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    mas.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}

// Baraja un array in situ (Fisher–Yates) para dar variedad en cada carga.
function anBarajar(arr) {
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
  }
  return arr;
}

// Carrusel: arrastre con ratón, deslizado táctil nativo, bucle infinito y flechas.
function initCarruseles(raiz) {
  (raiz || document).querySelectorAll('[data-an-carrusel]').forEach(function (car) {
    if (car.dataset.anCarruselListo) return;
    car.dataset.anCarruselListo = '1';
    montarCarrusel(car);
  });
}

function montarCarrusel(car) {
  var track = car.querySelector('[data-an-carrusel-track]');
  if (!track) return;
  var prev = car.querySelector('[data-an-carrusel-prev]');
  var next = car.querySelector('[data-an-carrusel-next]');

  var originales = Array.prototype.slice.call(track.children).filter(function (el) {
    return el.classList && el.classList.contains('an-prod-card');
  });
  if (!originales.length) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }

  // Variedad: barajar el orden en cada carga.
  if (car.hasAttribute('data-an-shuffle') && originales.length > 2) {
    anBarajar(originales).forEach(function (el) { track.appendChild(el); });
    originales = Array.prototype.slice.call(track.children);
  }

  // En un carrusel horizontal mostramos todas las tarjetas de una (sin la
  // animación de aparición por scroll, que dejaría clones ocultos).
  originales.forEach(function (el) { el.classList.remove('an-reveal'); el.classList.add('an-visible'); });

  var loop = car.hasAttribute('data-an-loop');
  var periodo = 0;
  var recolocando = false;
  var abajo = false, inicioX = 0, inicioScroll = 0, movido = false;

  function paso() { return Math.max(track.clientWidth * 0.85, 240); }

  function actualizarFlechas() {
    if (loop && periodo > 0) { if (prev) prev.hidden = false; if (next) next.hidden = false; return; }
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = track.scrollLeft >= max;
  }

  function activarLoop() {
    var antes = originales.map(function (el) { var c = el.cloneNode(true); c.setAttribute('data-an-clon', ''); return c; });
    var despues = originales.map(function (el) { var c = el.cloneNode(true); c.setAttribute('data-an-clon', ''); return c; });
    despues.forEach(function (c) { track.appendChild(c); });
    antes.forEach(function (c) { track.insertBefore(c, track.firstChild); });
    periodo = originales[0].getBoundingClientRect().left - track.firstElementChild.getBoundingClientRect().left;
    if (periodo > 0) { track.scrollLeft = periodo; } else { loop = false; }
  }

  function alScroll() {
    if (loop && !recolocando && !abajo && periodo > 0) {
      var x = track.scrollLeft;
      if (x < periodo * 0.5) { recolocando = true; track.scrollLeft = x + periodo; recolocando = false; }
      else if (x > periodo * 1.5) { recolocando = true; track.scrollLeft = x - periodo; recolocando = false; }
    }
    actualizarFlechas();
  }

  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });

  // Arrastrar con ratón (escritorio). En táctil se usa el scroll nativo.
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    abajo = true; movido = false;
    inicioX = e.clientX; inicioScroll = track.scrollLeft;
    track.classList.add('is-dragging');
  });
  window.addEventListener('pointermove', function (e) {
    if (!abajo) return;
    var dx = e.clientX - inicioX;
    if (Math.abs(dx) > 4) movido = true;
    track.scrollLeft = inicioScroll - dx;
  });
  function finArrastre() {
    if (!abajo) return;
    abajo = false;
    track.classList.remove('is-dragging');
    alScroll();
    setTimeout(function () { movido = false; }, 0);
  }
  window.addEventListener('pointerup', finArrastre);
  track.addEventListener('pointercancel', finArrastre);
  track.addEventListener('mouseleave', finArrastre);
  // Bloquea el clic al final de un arrastre (evita navegar sin querer).
  track.addEventListener('click', function (e) {
    if (movido) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  track.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', actualizarFlechas);

  // Montaje: medir el layout y activar el bucle. Se ejecuta una sola vez,
  // con rAF y un respaldo por setTimeout (algunos contextos no disparan rAF).
  function montar() {
    if (car.dataset.anMontado) return;
    car.dataset.anMontado = '1';
    var necesitaScroll = track.scrollWidth > track.clientWidth + 4;
    if (!necesitaScroll) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      car.classList.add('an-carrusel--estatico');
      return;
    }
    if (loop) activarLoop();
    actualizarFlechas();
  }
  if (window.requestAnimationFrame) window.requestAnimationFrame(montar);
  setTimeout(montar, 80);
}

// Recomendaciones de Shopify: se piden por AJAX y cambian según el producto.
function initRecomendados() {
  document.querySelectorAll('[data-an-recomendados]').forEach(function (cont) {
    var url = cont.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-an-recomendados]');
        if (nuevo) {
          cont.innerHTML = nuevo.innerHTML;
          initReveals();
          initCarruseles(cont);
          if (window.anWishlistSync) window.anWishlistSync();
        }
      })
      .catch(function () {});
  });
}
